import { z } from 'zod';
/**
 * Query-parameter primitives shared by every `/api/v1` list endpoint (KIR-4376).
 *
 * Shared rather than restated per resource for the same reason as the pagination
 * shape: a customer's generic client should be able to build a query for any
 * resource the same way, and two resources that parse `severity=a,b` slightly
 * differently is exactly the inconsistency that costs them a day.
 */
/** Sort direction. The same two words on every list endpoint. */
export const v1SortOrderSchema = z
    .enum(['asc', 'desc'])
    .describe('Sort direction.');
/**
 * A comma-separated multi-value filter (`severity=high,critical`).
 *
 * Chosen over the internal bracket notation (`severity[includes]=high`) because
 * the bracket form encodes an operator vocabulary that is an implementation
 * detail of the DataTable, and publishing it would freeze that vocabulary into
 * a customer contract for the life of `v1`.
 *
 * Values are trimmed and empty segments dropped, so a trailing comma or a stray
 * space is not an error. An absent parameter stays `undefined` rather than
 * becoming `[]` — the adapter reads that to mean "no filter", and an empty array
 * would read as "match nothing".
 */
export function csvParam(description) {
    return (z
        .string()
        .optional()
        // Required rather than optional so a filter added later cannot reach the
        // published spec as a bare, unexplained parameter: the comma-separated
        // format is invisible in the generated schema (a `.transform()` has no
        // JSON Schema equivalent), so prose is the only thing that conveys it.
        .describe(`${description} Comma-separated to pass several values.`)
        .transform(value => value === undefined
        ? undefined
        : value
            .split(',')
            .map(part => part.trim())
            .filter(part => part.length > 0)));
}
//# sourceMappingURL=query.js.map